<template>
  <div>
    <div class="chore-calendar-detail-container">
      <div class="chore-calendar-detail-top-container">
        <img
          class="chore-calendar-delete-icon"
          @click="selDeleteAssignment = true"
          src="@/assets/rentalButtonIcons/delete.svg"
        />
        <img @click="$emit('edit')" src="../../assets/EditIconGreen.svg" />
        <img @click="$emit('close')" src="../../assets/CloseIconGreen.svg" />
      </div>
      <hr
        style="
          border: none;
          border-top: 1px solid #e5e9ed;
          width: 116%;
          margin-left: -15px;
        "
      />
      <div class="chore-calendar-detail-bottom-container">
        <div class="chore-calendar-detail-title">{{ details.title }}</div>
        <div class="chore-calendar-detail-el">
          <img src="../../assets/UserIconGrey.svg" />
          <p>{{ details.user }}</p>
        </div>
        <div class="chore-calendar-detail-el">
          <img src="../../assets/CalendarIconGrey.svg" />
          <p>{{ details.date }}</p>
        </div>
        <div class="chore-calendar-detail-el">
          <img src="../../assets/HouseIconGrey.svg" />
          <p>{{ details.property }}</p>
        </div>
      </div>
    </div>
    <delete-popup
      v-if="selDeleteAssignment"
      @confirm="deleteAssignment()"
      @cancel="selDeleteAssignment = false"
      :thingName="'chore schedule'"
    />
  </div>
</template>

<script>
import DeletePopup from '../../components/GenericDeletePopup.vue'
export default {
  components: {
    DeletePopup
  },
  data() {
    return {
      selDeleteAssignment: false
    }
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {
          title: 'undefined',
          user: 'undefined',
          date: 'undefined',
          property: 'undefined'
        }
      }
    }
  },
  methods: {
    deleteAssignment() {
      this.$emit('delete-assignment', { ...this.details })
    }
  }
}
</script>

<style scoped>
.chore-calendar-detail-container {
  position: fixed;
  z-index: 1;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  justify-content: left;
  align-items: center;
  width: 300px;
  height: 250px;
  padding: 16px;
}

div.chore-calendar-detail-top-container {
  padding: 0 !important;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}

.chore-calendar-detail-top-container img {
  width: 18px;
  height: 18px;
  cursor: pointer;
  padding: 0px 8px 8px 8px;
}

img.chore-calendar-delete-icon {
  min-width: 24px;
  min-height: 24px;
  cursor: pointer;
}

.chore-calendar-detail-title {
  height: 42px;
  text-align: left;
  line-height: 47px;
  color: #4a4a4a;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  margin-top: 10px;
}

.chore-calendar-detail-el {
  display: flex;
  flex-flow: row nowrap;
  justify-content: left;
  align-items: center;
  height: 47px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
  color: rgba(0, 0, 0, 0.5);
}

.chore-calendar-detail-el img {
  width: 17px;
  height: 17px;
}

.chore-calendar-detail-el p {
  margin-top: 1em;
  margin-left: 16px;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .chore-calendar-detail-container {
    width: 280px !important;
    height: auto !important;
    min-height: 200px;
    max-width: 90vw;
    left: 50% !important;
    transform: translateX(-50%) !important;
    top: 20% !important;
  }

  .chore-calendar-detail-title {
    font-size: 14px !important;
    line-height: 32px !important;
    height: auto !important;
    margin-top: 8px !important;
  }

  .chore-calendar-detail-el {
    height: 36px !important;
    font-size: 14px !important;
    line-height: 32px !important;
  }

  .chore-calendar-detail-el img {
    width: 14px !important;
    height: 14px !important;
  }

  .chore-calendar-detail-el p {
    margin-left: 12px !important;
    font-size: 13px !important;
  }

  .chore-calendar-detail-top-container img {
    width: 16px !important;
    height: 16px !important;
    padding: 0px 6px 6px 6px !important;
  }

  img.chore-calendar-delete-icon {
    min-width: 20px !important;
    min-height: 20px !important;
  }
}

@media (max-width: 480px) {
  .chore-calendar-detail-container {
    width: 260px !important;
    max-width: 95vw;
    top: 15% !important;
    padding: 12px !important;
  }

  .chore-calendar-detail-title {
    font-size: 13px !important;
    line-height: 28px !important;
    margin-top: 6px !important;
  }

  .chore-calendar-detail-el {
    height: 32px !important;
    font-size: 13px !important;
    line-height: 28px !important;
  }

  .chore-calendar-detail-el img {
    width: 12px !important;
    height: 12px !important;
  }

  .chore-calendar-detail-el p {
    margin-left: 10px !important;
    font-size: 12px !important;
  }

  .chore-calendar-detail-top-container img {
    width: 14px !important;
    height: 14px !important;
    padding: 0px 4px 4px 4px !important;
  }

  img.chore-calendar-delete-icon {
    min-width: 18px !important;
    min-height: 18px !important;
  }
}

@media (max-width: 360px) {
  .chore-calendar-detail-container {
    width: 240px !important;
    max-width: 98vw;
    top: 10% !important;
    padding: 10px !important;
  }

  .chore-calendar-detail-title {
    font-size: 12px !important;
    line-height: 24px !important;
    margin-top: 4px !important;
  }

  .chore-calendar-detail-el {
    height: 28px !important;
    font-size: 12px !important;
    line-height: 24px !important;
  }

  .chore-calendar-detail-el img {
    width: 10px !important;
    height: 10px !important;
  }

  .chore-calendar-detail-el p {
    margin-left: 8px !important;
    font-size: 11px !important;
  }

  .chore-calendar-detail-top-container img {
    width: 12px !important;
    height: 12px !important;
    padding: 0px 3px 3px 3px !important;
  }

  img.chore-calendar-delete-icon {
    min-width: 16px !important;
    min-height: 16px !important;
  }
}
</style>
